/* Common Imports */

import React from "react";

/* Redux Imports */

import { connect } from "react-redux";
import StateInterface from "../redux-magic/state-interface";
import { updateReduxSessionThunk, wrapper } from "../redux-magic/store";
import { bottom_subscribe_buy_beegru_points, notifications_page } from "../redux-magic/sub-state-data/sub-state-data";

/* Component Imports */

import loadable from "@loadable/component";
import { Theme } from "@mui/material/styles";
import { useRouter } from "next/router";
import Layout from "../components/layout-components/Layout";

/* Loadable Components */

const Privacies = loadable(() => import("../components/page-sections/PrivacyAndTerms/Privacies"));

/* Library Functions */

import { validateClientSession } from "../lib/auth/helpers";
import authenticationTokenGenerator from "../lib/authentication_token_generator";

/*

& Next, let's export a getServerSideProps function to get the Agent's  session.

*/

export const getServerSideProps = wrapper.getServerSideProps((store: any) => async (context: any) => {
	const server_session: any = await authenticationTokenGenerator(context);
	return {
		props: {
			server_session: server_session,
		},
	};
});

const Privacy = ({
	server_session,
	session,
	redux_session,
	dispatch,
	new_listing_url,
	new_business_profile_url,
	showInactivityDialog,
	theme,
	profile_context,
	notification_data,
	newNotification,
	search_filter_state,
	searchanimationsettings,
	bottom_buy_subscription,
	open_post_modal,
}: {
	server_session: any;
	session: any;
	redux_session: StateInterface["redux_session"];
	dispatch: Function;
	new_listing_url: StateInterface["new_listing_url"];
	new_business_profile_url: StateInterface["new_business_profile_url"];
	showInactivityDialog: boolean;
	theme: Theme;
	profile_context: StateInterface["profile_context"];
	notification_data: StateInterface["notifications_page"];
	newNotification?: StateInterface["notification"] | null;
	search_filter_state: StateInterface["search_filters_state"];
	searchanimationsettings: StateInterface["search_animation_settings"];
	bottom_buy_subscription: StateInterface["bottom_subscribe_buy_beegru_points"];
	open_post_modal: StateInterface["open_post_modal"];
}) => {
	/* Setting redux_session */

	const [reduxSessionUpdated, setReduxSessionUpdated] = React.useState<boolean>(false);

	React.useEffect(() => {
		if (server_session && validateClientSession(server_session)) {
			dispatch(updateReduxSessionThunk(server_session));
		}
		setReduxSessionUpdated(true);
	}, [server_session, dispatch]);

	const router = React.useRef(useRouter()).current;

	return (
		<React.Fragment>
			<Layout
				title={"Privacy Policy"}
				description={"Privacy Policy"}
				canonicalUrl={process.env.PRODUCTION_URL + router.asPath.substring(1)}
				session={redux_session}
				redux_session_updated={reduxSessionUpdated}
				showInactivityDialog={showInactivityDialog}
				theme={theme}
				dispatch={dispatch}
				profile_context={profile_context}
				new_business_profile_url={new_business_profile_url ? new_business_profile_url : ""}
				new_listing_url={new_listing_url ? new_listing_url : ""}
				notifications={notification_data ? notification_data : notifications_page}
				new_notification={newNotification ? newNotification : null}
				search_filter_state={search_filter_state}
				searchanimationsettings={searchanimationsettings}
				bottom_buy_subscription={bottom_buy_subscription ? bottom_buy_subscription : bottom_subscribe_buy_beegru_points}
				open_post_modal={open_post_modal}
			>
				<div
					style={{
						paddingTop: "4rem",
					}}
				>
					<Privacies />
				</div>
			</Layout>
		</React.Fragment>
	);
};

export default connect(
	({
		globalState: {
			profile_context,
			new_listing_url,
			new_business_profile_url,
			notifications_page,
			redux_session,
			search_filters_state,
			search_animation_settings,
			bottom_subscribe_buy_beegru_points,
			open_post_modal,
		},
	}: {
		globalState: {
			profile_context: StateInterface["profile_context"];
			new_listing_url: StateInterface["new_listing_url"];
			new_business_profile_url: StateInterface["new_business_profile_url"];
			notifications_page: StateInterface["notifications_page"];
			redux_session: StateInterface["redux_session"];
			search_filters_state: StateInterface["search_filters_state"];
			search_animation_settings: StateInterface["search_animation_settings"];
			bottom_subscribe_buy_beegru_points: StateInterface["bottom_subscribe_buy_beegru_points"];
			open_post_modal: StateInterface["open_post_modal"];
		};
	}) => ({
		profile_context: profile_context,
		new_listing_url: new_listing_url,
		new_business_profile_url: new_business_profile_url,
		notification_data: notifications_page,
		redux_session: redux_session,
		search_filter_state: search_filters_state,
		searchanimationsettings: search_animation_settings,
		bottom_buy_subscription: bottom_subscribe_buy_beegru_points,
		open_post_modal: open_post_modal,
	}),
)(Privacy);
